import { render, staticRenderFns } from "./LicenseAgreement.vue?vue&type=template&id=d0a0d4d2&scoped=true"
import script from "./LicenseAgreement.vue?vue&type=script&lang=js"
export * from "./LicenseAgreement.vue?vue&type=script&lang=js"
import style0 from "./LicenseAgreement.vue?vue&type=style&index=0&id=d0a0d4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a0d4d2",
  null
  
)

export default component.exports